/* ============================================================================
 * GESKE - UK launch landing pages: gift-with-purchase + discount priming
 * ----------------------------------------------------------------------------
 * Listens for the shared newsletter-offer:success event fired by
 * <newsletter-offer-form> (geske-newsletter-offer.js) inside a
 * [data-landing-offer] wrapper and then:
 *   1. Personalises the success line with the first name (if given).
 *   2. Primes the checkout discount cookie via /discount/CODE so the code is
 *      applied automatically when the customer reaches checkout.
 *   3. Gift-with-purchase mode only: adds the gift bundle variants to the cart
 *      (line property _gwp keeps them identifiable and hidden from cart UI),
 *      skipping any already in the cart so a resubmit never duplicates them.
 *
 * Config is a JSON blob in <script type="application/json" data-gwp-config>:
 *   { "code": "UKGIFT", "variants": [123, ...], "addingText": "...",
 *     "addedText": "...", "errorText": "..." }
 * "variants" empty or absent = discount-only mode (no cart add).
 * ========================================================================== */
(function () {
  'use strict';

  function setStatus(wrap, msg) {
    var el = wrap.querySelector('[data-gwp-status]');
    if (el && msg) {
      el.hidden = false;
      el.textContent = msg;
    }
  }

  /* After the bundle is in the bag, hand the customer over to the shop (the
   * "Shop all devices" link, via /discount/CODE so the code is on the cart
   * session). The main theme's cart drawer then shows the bundle as a
   * provisional gift group with the spend meter (geske-cart.js) and opens
   * once on arrival when the flag below is set. */
  var ARRIVAL_KEY = 'geske-gwp-arrival';

  function scheduleRedirect(wrap, cfg) {
    if (!cfg.redirect || !cfg.redirectUrl) return;
    var el = wrap.querySelector('[data-gwp-redirect]');
    var delay = Math.max(600, parseInt(cfg.redirectDelay, 10) || 3000);
    if (el && cfg.redirectText) {
      el.hidden = false;
      el.textContent = cfg.redirectText;
    }
    try {
      if (cfg.openCart) window.sessionStorage.setItem(ARRIVAL_KEY, '1');
      // The offer bar carries the gift meter on the shop; make sure a bar the
      // customer closed earlier this session comes back for it.
      window.sessionStorage.removeItem('geske-announcement-closed');
    } catch (_) { /* storage blocked */ }
    window.setTimeout(function () {
      window.location.assign(cfg.redirectUrl);
    }, delay);
  }

  function addBundle(wrap, cfg) {
    setStatus(wrap, cfg.addingText || 'Adding your free bundle to your bag...');
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var inCart = {};
        (cart.items || []).forEach(function (item) { inCart[item.variant_id] = true; });
        var items = cfg.variants
          .filter(function (id) { return !inCart[id]; })
          .map(function (id) {
            return { id: id, quantity: 1, properties: { _gwp: cfg.code || 'gwp' } };
          });
        if (!items.length) {
          setStatus(wrap, cfg.addedText || 'Your free bundle is in your bag.');
          return null;
        }
        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (res) {
          if (!res.ok) throw new Error('cart/add.js responded ' + res.status);
          setStatus(wrap, cfg.addedText || 'Your free bundle is in your bag.');
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        });
      })
      .then(function () {
        scheduleRedirect(wrap, cfg);
      })
      .catch(function (err) {
        // Stay on the page so the fallback message (code still works at
        // checkout) is read; the success CTA remains available.
        if (window.console) console.warn('[landing-gwp] bundle add failed:', err);
        setStatus(wrap, cfg.errorText || 'We could not add the bundle automatically. Your code still works at checkout.');
      });
  }

  document.addEventListener('newsletter-offer:success', function (e) {
    var wrap = e.target && e.target.closest ? e.target.closest('[data-landing-offer]') : null;
    if (!wrap) return;

    var name = e.detail && e.detail.firstName ? e.detail.firstName : '';
    wrap.querySelectorAll('[data-success-name]').forEach(function (el) {
      el.textContent = name ? 'Thanks ' + name + '. ' : '';
    });

    var cfgEl = wrap.querySelector('[data-gwp-config]');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (_) { return; }

    if (cfg.code) {
      // Registers the discount against the cart session; ignore the redirect body.
      fetch('/discount/' + encodeURIComponent(cfg.code), { credentials: 'same-origin' }).catch(function () {});
    }
    if (cfg.variants && cfg.variants.length) {
      addBundle(wrap, cfg);
    } else {
      // Discount-only landers (no bundle): same hand-over, nothing to add first.
      scheduleRedirect(wrap, cfg);
    }
  });
})();
